import { render, staticRenderFns } from "./PageABCBookCompleted.vue?vue&type=template&id=508119c8&scoped=true&"
import script from "./PageABCBookCompleted.vue?vue&type=script&lang=js&"
export * from "./PageABCBookCompleted.vue?vue&type=script&lang=js&"
import style0 from "./PageABCBookCompleted.vue?vue&type=style&index=0&id=508119c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508119c8",
  null
  
)

export default component.exports